.table {
  display: grid;
  gap: 16px;
  font-size: 14px;
  line-height: 1.8;
}

.row {
  display: grid;
  gap: 10px;
}

.term {
  color: var(--color-gray-70, rgb(0 0 0 / 70%));
}

.definition {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 6px;
}

.item {
  a {
    display: inline-block;
    max-width: 323px;
    padding: 2.6px 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid var(--color-gray-20, rgb(0 0 0 / 20%));
    border-radius: 100px;

    &:hover:not(:disabled) {
      background-color: var(--color-gray-5, rgb(0 0 0 / 5%));
    }
  }
}

.referenceUrl {
  color: var(--color-gray-70, rgb(0 0 0 / 70%));
  text-decoration: underline;
}

.downloadButtonDef {
  display: grid;
  gap: 32px;
}

.location {
  display: flex;
  gap: 8px;
  color: var(--color-gray-70, rgb(0 0 0 / 70%));
  list-style: none;
}

.anchor {
  overflow-wrap: anywhere;
  text-decoration: underline;
}

.documents {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: start;
}

@media screen and (width >= 1024px) {
  .tableScreen {
    gap: 16px;
    font-size: 15px;
    line-height: 1.7;
  }

  .pressKitLinkBoxScreen {
    margin-top: 12px;
  }

  .downloadButtonDefScreen {
    gap: 40px;
  }

  .rowScreen {
    grid-template-columns: 262px 1fr;
  }
}

@container press-release-root (min-width: 1024px) {
  .tablePressReleaseRoot {
    gap: 16px;
    font-size: 15px;
    line-height: 1.7;
  }

  .pressKitLinkBoxPressReleaseRoot {
    margin-top: 12px;
  }

  .downloadButtonDefPressReleaseRoot {
    gap: 40px;
  }

  .rowPressReleaseRoot {
    grid-template-columns: 262px 1fr;
  }
}
